import type { LayoutSidebarModeGenericProps } from "@/components/Layout/Sidebar/Mode/types";
import React, { Fragment } from "react";

import MigratePageWeb3Wrapper from "@/features/migrate/ui/Page/Web3Wrapper";
import LayoutSidebarModePiggy from "@/components/Layout/Sidebar/Mode/Piggy";
import LayoutSidebarModeClaimRewards from "@/components/Layout/Sidebar/Mode/ClaimRewards";
import LayoutSidebarModeDeposit from "@/components/Layout/Sidebar/Mode/Deposit";
import LayoutSidebarModeFilters from "@/components/Layout/Sidebar/Mode/Filters";
import LayoutSidebarModeRewardsApy from "@/components/Layout/Sidebar/Mode/RewardsApy";
import LayoutSidebarModeTransmute from "@/components/Layout/Sidebar/Mode/Transmute";
import LayoutSidebarModeWithdraw from "@/components/Layout/Sidebar/Mode/Withdraw";

import useGetOverlay from "@/store/hooks/useGetOverlay";

export default function LayoutSidebarModeRightBase(props: LayoutSidebarModeGenericProps) {
  const mode = useGetOverlay();
  return (
    <Fragment>
      {mode === "deposit" && <LayoutSidebarModeDeposit {...props} />}
      {mode === "withdraw" && <LayoutSidebarModeWithdraw {...props} />}
      {mode === "filters" && <LayoutSidebarModeFilters {...props} />}
      {mode === "rewards-apy" && <LayoutSidebarModeRewardsApy {...props} />}
      {mode === "transmute" && <LayoutSidebarModeTransmute {...props} />}
      {mode === "claim-rewards" && <LayoutSidebarModeClaimRewards {...props} />}
      {mode === "migrate" && <MigratePageWeb3Wrapper {...props} />}
      {mode !== undefined && ["piggy-deposit", "piggy-harvest", "piggy-withdraw"].includes(mode) && <LayoutSidebarModePiggy mode={mode} />}
    </Fragment>
  );
}
